export const UPSELL_PRODUCT = "upsell product"
export const QUICK_VIEW = "quick view"
export const CLOSE = "close"
export const QUICK_VIEW_MODAL = "quick view modal"
export const ADD_TO_CART = "add to cart"
export const VIEW_FULL_DETAILS = "view full details"
export const DIMENSIONS = "dimensions"
export const COLOR_SELECTION = "color selection"
export const LIST_PRICE = "list price"
export const CAROUSEL_IMAGE = "carousel image"
export const REVIEW = "write a review"
export const Download = "download"
export const NOTIFY = "notify me"
export const SPEC_SHEET = "specification sheet"
export const GUIDE = "installation guide"
export const REVIEW_CONTAINER_ID = "#product-review"
